import styled from "@emotion/styled"
import { Modal } from "@mui/material"
import { DonationMessages } from "app/[locale]/(layout)/donation-application-form/page"
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { Desktop, FormSubmitFailIcon, Mobile, NewText, useIsDesktop } from "ui"
import { sharedColors } from "ui/theme/colors"

const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  display: flex;
  padding: 40px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  z-index: 10;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    position: relative;
    bottom: unset;
    border-radius: 0;
    padding-bottom: 160px;
  }
  &:focus {
    outline: none;
  }
`
const StyledButton = styled.button`
  background-color: white;
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 200px;
  border: 2px solid #000;
  outline: none;
  min-width: 121px;
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    border: 2px solid #6f6f6f;
  }
`

function FailModal({
  messages,
  setFormIsSubmitted,
}: {
  messages: DonationMessages
  setFormIsSubmitted: Dispatch<SetStateAction<boolean>>
}) {
  const [open, setOpen] = useState(true)
  const isDesktop = useIsDesktop()
  useEffect(() => {
    window.scrollTo({
      top: isDesktop ? 320 : 0,
      behavior: "auto",
    })
    if (!isDesktop) {
      document.body.style.overflow = "hidden"
    }
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [isDesktop])

  const handleClose = () => {
    setOpen(false)
    setFormIsSubmitted(false)
  }
  const handleButtonPress = () => {
    handleClose()
  }
  return (
    <>
      <Mobile>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <StyledContainer>
            <FormSubmitFailIcon />
            <NewText
              desktopFontSize={14}
              desktopFontWeight="400"
              desktopLineHeight="20px"
              mobileFontSize={12}
              mobileFontWeight="400"
              mobileLineHeight={"17px"}
              component="h1"
              color={"black"}
              style={{ maxWidth: isDesktop ? "403px" : "60%" }}
              textAlign="center"
            >
              {messages.donationErrorDescription}
            </NewText>
            <StyledButton onClick={handleButtonPress}>
              <NewText
                component={"p"}
                desktopFontSize={16}
                mobileFontSize={14}
                desktopFontWeight={600}
                color={sharedColors.black}
              >
                {messages.donationTryAgain}
              </NewText>
            </StyledButton>
          </StyledContainer>
        </Modal>
      </Mobile>
      <Desktop>
        <StyledContainer>
          <FormSubmitFailIcon />
          <NewText
            desktopFontSize={14}
            desktopFontWeight="400"
            desktopLineHeight="20px"
            mobileFontSize={12}
            mobileFontWeight="400"
            mobileLineHeight={"17px"}
            component="h1"
            color={"black"}
            style={{ maxWidth: isDesktop ? "403px" : "60%" }}
            textAlign="center"
          >
            {messages.donationErrorDescription}
          </NewText>
          <StyledButton onClick={handleButtonPress}>{messages.donationTryAgain}</StyledButton>
        </StyledContainer>
      </Desktop>
    </>
  )
}

export default FailModal
